import { colors } from "assets/styles/colors";
import { Grid } from "assets/styles/globalStyles";
import { FontSizes } from "utils/enums";
import styled from "styled-components";


export const PrivacyWrapper = styled.div`
    padding-top:145px;
    position:relative;
    min-height:100vh;
    width:100%

    
    b, strong, li {
        line-height: 25px;
    }
    .___comn_txt{
        p{
            margin:0;
        }
    }
    .__founder{
        p{
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            flex: 1 1;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        h2, img{
            display: none;
        }
    }
`